import { useTranslation } from 'module/hooks/use-translation';
import { faClose, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { InputProps } from 'antd/lib/input';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '../button';
import { HeightStyle, Input } from './input';
import { FontAwesomeIcon } from '../icon/icon';
import { CenterAlignedBox } from '../layout/layout';

const SearchIconWrapper = styled(CenterAlignedBox)<{ size?: SizeType }>`
  width: ${HeightStyle};
  height: ${HeightStyle};
  justify-content: center;
  color: var(--icon-primary);
`;

export const Wrapper = styled.div<{ size?: SizeType }>`
  position: relative;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  ${SearchIconWrapper} {
    left: 0;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  ${Button} {
    position: absolute;
    right: 0;
    top: 0;
  }
  ${Input} {
    padding-left: ${HeightStyle};
    padding-right: 40px;
  }
`;
type SearchInputProps = InputProps & {
  onClear: () => void;
};

const SearchInput = forwardRef<any, SearchInputProps>(
  ({ onClear: clear, placeholder, value, className, size, ...props }, ref) => {
    const defaultPlaceholder = useTranslation('search');

    return (
      <Wrapper className={className} size={size}>
        <SearchIconWrapper size={size}>
          <FontAwesomeIcon icon={faSearch} size={12} />
        </SearchIconWrapper>
        <Input
          autoFocus
          placeholder={defaultPlaceholder ?? placeholder}
          value={value}
          ref={ref}
          size={size}
          {...props}
        />
        {value ? (
          <Button
            type="text"
            icon={<FontAwesomeIcon icon={faClose} size={12} />}
            onClick={clear}
          />
        ) : null}
      </Wrapper>
    );
  },
);

SearchInput.displayName = 'SearchInputExpanded';
export const SearchInputExpanded = styled(SearchInput)``;
